const roles = {
  admin: {
    type: "admin",
    name: "Manager"
  },
  designer: {
    type: "designer",
    name: "Designer"
  },
  user: {
    type: "user",
    name: "Idea Maker"
  }
};

const colors = {
  "#4f5555": {
    name: "Dark Heather",
    hex: "#4f5555",
    checked: false
  },
  "#d7dbdc": {
    name: "Heather Grey",
    hex: "#d7dbdc",
    checked: false
  },
  "#676c98": {
    name: "Heather Blue",
    hex: "#676c98",
    checked: false
  },
  "#000000": {
    name: "Black",
    hex: "#000000",
    checked: false
  },
  "#15232b": {
    name: "Navy",
    hex: "#15232b",
    checked: false
  },
  "#cfd1d1": {
    name: "Silver",
    hex: "#cfd1d1",
    checked: false
  },
  "#1c4086": {
    name: "Royal Blue",
    hex: "#1c4086",
    checked: false
  },
  "#31261d": {
    name: "Brown",
    hex: "#31261d",
    checked: false
  },
  "#818189": {
    name: "Slate",
    hex: "#818189",
    checked: false
  },
  "#b71111": {
    name: "Red",
    hex: "#b71111",
    checked: false
  },
  "#3f3e3c": {
    name: "Asphalt",
    hex: "#3f3e3c",
    checked: false
  },
  "#5e9444": {
    name: "Grass",
    hex: "#5e9444",
    checked: false
  },
  "#4a4f26": {
    name: "Olive",
    hex: "#4a4f26",
    checked: false
  },
  "#006136": {
    name: "Kelly Green",
    hex: "#006136",
    checked: false
  },
  "#8fb8db": {
    name: "Baby Blue",
    hex: "#8fb8db",
    checked: false
  },
  "#ffffff": {
    name: "White",
    hex: "#ffffff",
    checked: false
  },
  "#f0e87b": {
    name: "Lemon",
    hex: "#f0e87b",
    checked: false
  },
  "#6e0a25": {
    name: "Cranberry",
    hex: "#6e0a25",
    checked: false
  },
  "#f8a3bc": {
    name: "Pink",
    hex: "#f8a3bc",
    checked: false
  },
  "#ff5c39": {
    name: "Orange",
    hex: "#ff5c39",
    checked: false
  },
  "#514689": {
    name: "Purple",
    hex: "#514689",
    checked: false
  }
};

const winter_colors = {
  "#4f5555": {
    name: "Dark Heather",
    hex: "#4f5555",
    checked: false
  },
  "#d7dbdc": {
    name: "Heather Grey",
    hex: "#d7dbdc",
    checked: false
  },
  "#000000": {
    name: "Black",
    hex: "#000000",
    checked: false
  },
  "#15232b": {
    name: "Navy",
    hex: "#15232b",
    checked: false
  },
  "#1c4086": {
    name: "Royal Blue",
    hex: "#1c4086",
    checked: false
  }
};

export default { roles, colors, winter_colors };

export { roles, colors, winter_colors };
